//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux';
import { AiOutlineDownload, AiOutlineFolderView, AiOutlineUpload } from 'react-icons/ai'
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import QualifiedTeacherSkeleton from './qualifiedTeacherSkeleton'
import BulkUploadModalModule from 'app_components/modules/admin/bulkUploadModal'
import ModalQualifiedTeacher from 'app_components/modules/ModalQualifiedTeacher/ModalQualifiedTeacher';
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IQualifiedTeacherListItem } from 'app_types/admin/qualifiedTeacher/qualifiedTeacherTypes'

// @end

// @INFO Import services
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import UserService from 'app_services/user/userService';
import { routingService } from 'app_services/routingService';
// @end

// @INFO Import Styles
import './../qualifiedTeacherScreen.scss'
import { MdRateReview } from 'react-icons/md';
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent';
import QualifiedTeacherService from 'app_services/admin/qualifiedTeacher/qualifiedTeacherService';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';

// @ADD Component types
interface IQualifiedTeacherScreenLayoutProps {
  teacherList: IQualifiedTeacherListItem[],
  status: null | 'loading' | 'error',
  add: boolean,
  edit: boolean,
  view: boolean,
  editData: any,
  selectedRow: null | string,
  pagination: IPagination,
  addTeacher: any,
  updateTeacher: any,
  showAddUserForm: (add: boolean) => void,
  showEditUserForm: (edit: boolean, editData?: any) => void,
  onViewerRow: (view: boolean, editData?: any) => void,
  onPageChange: (page: number) => void,
  onRowClick: (row: any) => void,
  removeTeacher: (userId: string) => void,
  onSearch: (search: string) => void,
  showModal: (modal: boolean) => void
}

const QualifiedTeacherScreenLayout: React.FC<IQualifiedTeacherScreenLayoutProps> = (props) => {

  const userService: UserService = new UserService();
  const qualifiedTeacherService = new QualifiedTeacherService()

  const screenNotifications: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  const auth = useSelector((state: any) => state.auth ? state.auth : null)

  const [modalTeacherQualificate, setModalTeacherQualificate] = useState<{status: boolean, teacherId: null | string}>({status: false, teacherId: null})
  const [uploadBulkFormStatus, setUploadBulkFormStatus] = useState<boolean>(false)
  const [loadingReport, setLoadingReport] = useState<boolean>(false)


  const [colors] = useColors()

  const { t } = useTranslation()

  const handleUploadBulkModal = () => {
    setUploadBulkFormStatus(true)
  }

  const handleCloseUploadBulkModal = (data: any) => {
    setUploadBulkFormStatus(false)
    if (data?.status === true) {
      screenNotifications.fireToast({
        'message': 'El archivo se ha cargado, para verificar el proceso ve al log de carga',
        'status': 'success'
      })
    }
  }

  const handleModalQualificateTeacher = (teacher: IQualifiedTeacherListItem) => {
    setModalTeacherQualificate({status: true, teacherId: teacher.userData?._id || null})
  }

  const handleCloseModalQualificateTeacher = (data: any) => {
    setModalTeacherQualificate({status: false, teacherId: null})
  }

  const handleClickDownloadReport = async () => {
    setLoadingReport(true)
    const response = await qualifiedTeacherService.generateReport()
    if (response?.code  === 200 && response?.path) {
      window.open(response.path, '_blank', 'noreferrer')
    }
    setLoadingReport(false)
  }

  return(
    <AppContainer>
       <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.qualifiedTeacher')}`]} />

        <div className='user-screen'>

          {props.status === 'loading' && (
            <QualifiedTeacherSkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t('screens.qualifiedTeacher.title')}</h2>

              <DataTableComponent
                data={props.teacherList}
                headerKeys={[
                  `${t('components.dataTable.headers.first_name')}`,
                  `${t('components.dataTable.headers.last_name')}`,
                  `${t('components.dataTable.details.user_name')}`,
                  `${t('components.dataTable.details.email')}`,
                  `${t('components.dataTable.headers.teacher.contract_type_name')}`,
                  `${t('components.dataTable.headers.teacher.is_teacher')}`,
                  `${t('components.dataTable.headers.teacher.is_tutor')}`,
                ]}
                keys={[
                  'userData.profile.first_name',
                  'userData.profile.last_name',
                  'userData.username',
                  'userData.email',
                  'userData.profile.contractType.type',
                  'userData.profile.contractType.isTeacher',
                  'userData.profile.contractType.isTutor',
                ]}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[
                  { name: `${t('components.dataTable.details.email')}`, key: 'userData.email' },
                ]}
                onSearch={props.onSearch}
                onPageChange={props.onPageChange}
                onViewerRow={props.onViewerRow}
                onModal={props.showModal}
                headerButtons={() => {
                  return (
                    <>
                      {userService.can('permission:qualifiedTeacher_upload_bulk', 'module:qualifiedTeacher') && (
                        <>
                          <button
                            className='btn btn-link btn-sm'
                            data-tip={t('screens.qualifiedTeacher.qualified.bulk_upload.title')}
                            onClick={() => handleUploadBulkModal()}
                          >
                            <AiOutlineUpload size="25px" color={colors.primary} />
                          </button>
                          <TooltipComponent text='Descargar reporte'>
                            <ButtonComponent loading={loadingReport} onClick={handleClickDownloadReport} style={{ padding: '0.4rem 0.6rem' }}>
                              <ButtonComponent.Icon>
                                <AiOutlineDownload size="25px" color={colors.primary} />
                              </ButtonComponent.Icon>
                            </ButtonComponent>
                          </TooltipComponent>
                          <Link
                            className=''
                            to={routingService.getSecurePath('/admin/document-processor/qualified-teacher')}
                            target="_blank"
                          >
                            <OverlayTrigger
                              trigger={['hover', 'focus']}
                              placement={'top'}
                              overlay={
                                <Tooltip id='toolip-view-lgos'>
                                  {t('screens.qualifiedTeacher.qualified.view_logs.title')}
                                </Tooltip>
                              }>
                                <AiOutlineFolderView size="25px" color={colors.primary} />
                            </OverlayTrigger>
                          </Link>
                        </>
                      )}
                    </>
                  )
                }}
                rowButtons={(item: IQualifiedTeacherListItem) => {
                  return (
                    <>
                      <button
                        className='btn btn-link btn-sm'
                        data-tip={t('screens.qualifiedTeacher.qualified.modal_qualificate.title')}
                        onClick={() => handleModalQualificateTeacher(item)}
                      >
                        <MdRateReview size="25px" color={colors.primary} />
                      </button>
                    </>
                  )
                }}
              />
            </>
          )}

          {uploadBulkFormStatus && (
            <BulkUploadModalModule
              open={uploadBulkFormStatus}
              handleClose={handleCloseUploadBulkModal}
              header={{
                title: t("screens.qualifiedTeacher.qualified.bulk_upload.title"),
                closeButton: true
              }}
              endpoint={{
                method: 'POST',
                url: '/api/admin/teacher/upload',
                params: {
                  userID: auth?.user?.data?.id,
                  sendEmail: false
                }
              }}
              showErrors={false}
            />
          )}
          {modalTeacherQualificate?.status && modalTeacherQualificate?.teacherId && (
            <ModalQualifiedTeacher
              open={modalTeacherQualificate.status}
              teacherId={modalTeacherQualificate.teacherId}
              hideCloseButton
              onClose={handleCloseModalQualificateTeacher}
            />
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default QualifiedTeacherScreenLayout
